var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { "max-width": "45%", bus: _vm.busModal, fixedActions: "" },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function() {
            return [
              _c("Title", {
                attrs: {
                  title: _vm.WHATSAPP_CONECTAR_TEXT.titulo,
                  underlined: ""
                }
              })
            ]
          },
          proxy: true
        },
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "div",
                { staticClass: "d-flex align-center justify-end mt-4" },
                [
                  _c(
                    "BaseButton",
                    { attrs: { underlined: "" }, on: { click: close } },
                    [_vm._v("Fechar")]
                  )
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _c(
        "div",
        { staticClass: "pa-1 mb-4" },
        [
          _c(
            "FeedbackWrapper",
            { attrs: { loading: _vm.carregando, "min-height": 160 } },
            [
              _vm.semAcesso
                ? _c("div", { attrs: { "data-test": "wa-sem-acesso" } }, [
                    _c(
                      "p",
                      { staticClass: "az-text-secondary az-size-14 mb-0" },
                      [_vm._v(" " + _vm._s(_vm.mensagemSemAcesso) + " ")]
                    )
                  ])
                : _vm.estaAtivo
                ? _c(
                    "div",
                    { attrs: { "data-test": "wa-ativo" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-center az-gap-small mb-3 wa-ok"
                        },
                        [
                          _c("icon-svg", {
                            staticClass: "wa-ok__icon",
                            attrs: { name: "mdi-whatsapp", size: "20" }
                          }),
                          _c(
                            "span",
                            {
                              staticClass:
                                "az-text-primary az-size-14 font-semibold"
                            },
                            [_vm._v(" WhatsApp conectado ")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "p",
                        { staticClass: "az-text-secondary az-size-14 mb-1" },
                        [
                          _vm._v(" Número "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.vinculo.numero_mascarado || "—"))
                          ]),
                          _vm.verificadoEmFormatado
                            ? _c("span", [
                                _vm._v(
                                  " · desde " +
                                    _vm._s(_vm.verificadoEmFormatado)
                                )
                              ])
                            : _vm._e()
                        ]
                      ),
                      _c(
                        "p",
                        { staticClass: "az-text-secondary az-size-14 mb-3" },
                        [
                          _vm._v(
                            " Pergunte por lá o mesmo que perguntaria aqui. Alguns exemplos: "
                          )
                        ]
                      ),
                      _c(
                        "ul",
                        { staticClass: "wa-exemplos mb-4" },
                        _vm._l(_vm.exemplos, function(exemplo) {
                          return _c(
                            "li",
                            {
                              key: exemplo,
                              staticClass: "az-text-primary az-size-14"
                            },
                            [_vm._v(" " + _vm._s(exemplo) + " ")]
                          )
                        }),
                        0
                      ),
                      _c("LinhaDeToggle", {
                        staticClass: "mb-4",
                        attrs: {
                          rotulo: _vm.WHATSAPP_CONECTAR_TEXT.escrita.rotulo,
                          ajuda: _vm.WHATSAPP_CONECTAR_TEXT.escrita.ajuda,
                          value: Boolean(_vm.vinculo.escrita_habilitada),
                          disabled: Boolean(_vm.salvando.escrita_habilitada),
                          "data-test": "wa-escrita"
                        },
                        on: { change: _vm.alternarEscrita }
                      }),
                      _c(
                        "p",
                        {
                          staticClass:
                            "az-text-primary az-size-14 font-semibold mb-2"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.WHATSAPP_CONECTAR_TEXT.avisos.titulo) +
                              " "
                          )
                        ]
                      ),
                      _vm._l(_vm.WHATSAPP_CONECTAR_TEXT.avisos.itens, function(
                        item
                      ) {
                        return _c("LinhaDeToggle", {
                          key: item.chave,
                          staticClass: "mb-4",
                          attrs: {
                            rotulo: item.rotulo,
                            ajuda: item.ajuda,
                            value: Boolean(_vm.vinculo[item.chave]),
                            disabled: Boolean(_vm.salvando[item.chave]),
                            "data-test": "wa-pref-" + item.chave
                          },
                          on: {
                            change: function($event) {
                              return _vm.alternarPreferencia(item, $event)
                            }
                          }
                        })
                      }),
                      _vm.mostraOnboarding
                        ? _c(
                            "div",
                            {
                              staticClass: "mb-4",
                              attrs: { "data-test": "wa-onboarding" }
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "az-text-primary az-size-14 font-semibold mb-1"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.WHATSAPP_CONECTAR_TEXT.onboarding
                                          .titulo
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "az-text-secondary az-size-14 mb-2"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.WHATSAPP_CONECTAR_TEXT.onboarding
                                          .ajuda
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _vm.podeIniciarOnboarding
                                ? _c(
                                    "BaseButton",
                                    {
                                      attrs: {
                                        primary: "",
                                        fitContent: "",
                                        loading: _vm.iniciandoOnboarding,
                                        "data-test": "wa-onboarding-iniciar"
                                      },
                                      on: { click: _vm.confirmarOnboarding }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.WHATSAPP_CONECTAR_TEXT
                                              .onboarding.botao
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm.onboardingStatusTexto
                                ? _c("BaseStatus", {
                                    attrs: {
                                      text: "",
                                      "preserve-case": "",
                                      content: _vm.onboardingStatusTexto,
                                      color: _vm.onboardingStatusCor,
                                      "data-test": "wa-onboarding-status"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "BaseButton",
                        {
                          attrs: {
                            outline: "",
                            fitContent: "",
                            loading: _vm.revogando
                          },
                          on: { click: _vm.confirmarDesconexao }
                        },
                        [_vm._v(" Desconectar ")]
                      )
                    ],
                    2
                  )
                : _vm.codigoVigente
                ? _c("div", { attrs: { "data-test": "wa-pendente" } }, [
                    _c(
                      "p",
                      { staticClass: "az-text-secondary az-size-14 mb-3" },
                      [
                        _vm._v(
                          " Envie o código abaixo para o WhatsApp da AAWZ Intelligence. Assim que a mensagem chegar, seu número fica conectado a esta conta. "
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "wa-codigo ia-texto-titulo-cartao pa-4 text-center mb-3",
                        attrs: { "data-test": "wa-codigo" }
                      },
                      [_vm._v(_vm._s(_vm.vinculo.codigo))]
                    ),
                    _c(
                      "div",
                      { staticClass: "d-flex align-center az-gap-small mb-3" },
                      [
                        _vm.vinculo.link_wa
                          ? _c(
                              "BaseButton",
                              {
                                attrs: {
                                  primary: "",
                                  fitContent: "",
                                  "data-test": "wa-abrir"
                                },
                                on: { click: _vm.abrirWhatsapp }
                              },
                              [
                                _c("icon-svg", {
                                  staticClass: "mr-1",
                                  attrs: { name: "mdi-whatsapp", size: "16" }
                                }),
                                _vm._v(" Abrir WhatsApp com o código ")
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "BaseButton",
                          {
                            attrs: {
                              outline: "",
                              fitContent: "",
                              loading: _vm.gerando
                            },
                            on: { click: _vm.gerarCodigo }
                          },
                          [_vm._v(" Gerar outro código ")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "p",
                      { staticClass: "az-text-secondary az-size-12 mb-1" },
                      [
                        _vm._v(
                          ' Ou mande a mensagem "' +
                            _vm._s(_vm.vinculo.codigo) +
                            '" para '
                        ),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.numeroIaFormatado ||
                                "o número da AAWZ Intelligence"
                            )
                          )
                        ]),
                        _vm._v(". O código vale por 10 minutos. ")
                      ]
                    ),
                    _c(
                      "p",
                      {
                        staticClass:
                          "az-text-secondary az-size-12 mb-0 d-flex align-center az-gap-small"
                      },
                      [
                        _c("v-progress-circular", {
                          attrs: { indeterminate: "", size: "14", width: "2" }
                        }),
                        _vm._v(" Aguardando sua mensagem… ")
                      ],
                      1
                    )
                  ])
                : _vm.codigoExpirado
                ? _c(
                    "div",
                    { attrs: { "data-test": "wa-expirado" } },
                    [
                      _c(
                        "p",
                        { staticClass: "az-text-secondary az-size-14 mb-3" },
                        [
                          _vm._v(
                            " O código expirou antes de ser enviado. Gere outro e envie em até 10 minutos. "
                          )
                        ]
                      ),
                      _c(
                        "BaseButton",
                        {
                          attrs: {
                            primary: "",
                            fitContent: "",
                            loading: _vm.gerando
                          },
                          on: { click: _vm.gerarCodigo }
                        },
                        [_vm._v(" Gerar novo código ")]
                      )
                    ],
                    1
                  )
                : _c(
                    "div",
                    { attrs: { "data-test": "wa-nenhum" } },
                    [
                      _c(
                        "p",
                        { staticClass: "az-text-secondary az-size-14 mb-2" },
                        [
                          _vm._v(
                            " Converse com a AAWZ Intelligence pelo WhatsApp: patrimônio de um cliente, suas reuniões e tarefas do dia, o que foi decidido na última reunião. "
                          )
                        ]
                      ),
                      _c(
                        "p",
                        { staticClass: "az-text-secondary az-size-12 mb-3" },
                        [
                          _vm._v(
                            " As respostas podem conter dados dos seus clientes e serão enviadas ao WhatsApp que você conectar. Você pode desconectar a qualquer momento. "
                          )
                        ]
                      ),
                      _c(
                        "BaseButton",
                        {
                          attrs: {
                            primary: "",
                            fitContent: "",
                            loading: _vm.gerando
                          },
                          on: { click: _vm.gerarCodigo }
                        },
                        [
                          _c("icon-svg", {
                            staticClass: "mr-1",
                            attrs: { name: "mdi-whatsapp", size: "16" }
                          }),
                          _vm._v(" Gerar código de conexão ")
                        ],
                        1
                      )
                    ],
                    1
                  )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }